import(/* webpackMode: "eager" */ "/vercel/path0/components/server-info.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/components/footer.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/components/header.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.0.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js")